import { commonOverrides } from './base.js'

export const createLightTheme = (given) => {
  const vars = { ...given }
  if (!vars.PRIMARY_COLOR) vars.PRIMARY_COLOR = '#63e2b7'
  if (!vars.INFO_COLOR) vars.INFO_COLOR = '#70c0e8'
  if (!vars.SUCCESS_COLOR) vars.SUCCESS_COLOR = '#63e2b7'
  if (!vars.ERROR_COLOR) vars.ERROR_COLOR = '#e88080'
  if (!vars.WARNING_COLOR) vars.WARNING_COLOR = '#f2c97d'
  if (!vars.TEXT_COLOR) vars.TEXT_COLOR = '#000'
  if (!vars.BASE_COLOR) vars.BASE_COLOR = '#FFF'
  if (!vars.BASE_INVERT_COLOR) vars.BASE_INVERT_COLOR = '#000'

  return {
    common: commonOverrides(vars),
  }
}
